import {memo} from "react";
import PropTypes from "prop-types";

const ReelCell = memo(({value}) => <div className="reel-cell">{value}</div>);
ReelCell.displayName = 'ReelCell';

/** Pure presentation — the animation is driven imperatively via `trackRef`. */
const ReelWindow = ({trackRef, measureRef, cellHeight, strip}) => (
    <div className="reel-window mx-auto w-full max-w-4xl mb-6" style={{height: `${cellHeight * 3}px`}}>
        {/* Hidden measurer: gives us the real row height before the first paint. */}
        <div className="absolute opacity-0 pointer-events-none" aria-hidden>
            <div ref={measureRef} className="reel-cell">XXXXXXXXX</div>
        </div>

        {/* Decorative: 60 scrolling cells are noise to a screen reader. The outcome
            is announced through the live region beside the spin button. */}
        <div ref={trackRef} className="reel-track" aria-hidden="true">
            {strip.length === 0
                ? <div className="reel-cell">—</div>
                : strip.map((value, index) => <ReelCell key={index} value={value}/>)}
        </div>

        <div className="reel-highlight" style={{height: `${cellHeight}px`}}/>
    </div>
);

ReelWindow.propTypes = {
    trackRef: PropTypes.object.isRequired,
    measureRef: PropTypes.object.isRequired,
    cellHeight: PropTypes.number.isRequired,
    strip: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default memo(ReelWindow);
